"use client";

import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ActivityCard } from "../activity-card";
import type { EnrichedActivity } from "./activity-selector";

type ActivityDetailProps = {
  activity: EnrichedActivity;
  note: string;
  onNoteChange: (value: string) => void;
  onBack: () => void;
};

export function ActivityDetail({
  activity: entry,
  note,
  onNoteChange,
  onBack,
}: ActivityDetailProps) {
  const { activity, level } = entry;

  return (
    <div className="animate-in space-y-6 duration-300 slide-in-from-right">
      <div className="mb-2 flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          className="z-1000 h-10 gap-2 rounded-full bg-surface/60 pr-4 pl-2 backdrop-blur-sm hover:bg-surface"
          onClick={onBack}
        >
          <ChevronLeft className="h-5 w-5 text-text-primary" />
          <span className="font-medium text-text-primary">Back</span>
        </Button>
        <h3 className="text-lg font-semibold">Add a note (optional)</h3>
      </div>

      <div className="pointer-events-none">
        <ActivityCard
          activitySkill={{
            activityId: activity.id,
            activity,
            level: level || null,
          }}
          variant="default"
        />
      </div>

      <div className="space-y-2">
        <Textarea
          id="activity-note"
          placeholder="I'd love to join your Thursday run crew."
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          className="min-h-32 rounded-2xl border-border bg-surface-alt px-4 py-3 text-text-primary transition-colors focus:bg-surface"
        />
      </div>
    </div>
  );
}
